export enum DocumentTag {
  Clinical = 'Clinical',
  Lab = 'Lab',
  Document = 'Document',
  Other = 'Other',
  'Rx Image' = 'Rx Image',
}

export type LabelType = 'any' | 'label' | 'monograph' | 'medGuide'
